import React from 'react';
import { cx } from '@/ui/utils/cx';

export type AppFieldGridProps = {
  columns?: 2 | 3 | 4;
  className?: string;
  children: React.ReactNode;
};

export function AppFieldGrid({ columns = 4, className, children }: AppFieldGridProps) {
  return (
    <div className={cx('app-field-grid', `app-field-grid--cols-${columns}`, className)}>
      {children}
    </div>
  );
}

export function AppFieldGridSpan({
  span = 'full',
  className,
  children,
}: {
  span?: 2 | 'full';
  className?: string;
  children: React.ReactNode;
}) {
  return (
    <div
      className={cx(
        span === 2 && 'app-field-grid__span-2',
        span === 'full' && 'app-field-grid__full',
        className,
      )}
    >
      {children}
    </div>
  );
}
